(function () {
  'use strict';

  function initMobileMenu() {
    var dialog = document.getElementById('mobile-menu');
    var trigger = document.querySelector('.mobile-menu-toggle');

    if (!dialog || !trigger || typeof dialog.showModal !== 'function') {
      return;
    }

    var mobile = window.matchMedia('(max-width: 991.98px)');
    var navigation = dialog.querySelector('.mobile-menu__nav');
    var closeButton = dialog.querySelector('.mobile-menu__close');
    var scrollPosition = null;
    var bodyStyles = {};
    var scrollProperties = ['position', 'top', 'left', 'right', 'overflow', 'padding-right'];
    var pointerStartedOutside = false;

    // Separate disclosure buttons keep parent pages navigable at every depth.
    navigation.querySelectorAll('li').forEach(function (item, index) {
      var submenu = Array.from(item.children).find(function (child) { return child.tagName === 'UL'; });
      var link = Array.from(item.children).find(function (child) { return child.tagName === 'A'; });

      if (!submenu || !link) {
        return;
      }

      var toggle = document.createElement('button');
      var expanded = item.classList.contains('current-menu-ancestor') || item.classList.contains('current_page_ancestor');
      submenu.id = 'mobile-submenu-' + index;
      submenu.hidden = !expanded;
      toggle.type = 'button';
      toggle.className = 'mobile-menu__submenu-toggle';
      toggle.setAttribute('aria-controls', submenu.id);
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.setAttribute('aria-label', navigation.dataset.submenuLabel.replace('%s', link.textContent.trim()));
      item.classList.add('mobile-menu__has-submenu');
      item.insertBefore(toggle, submenu);

      toggle.addEventListener('click', function () {
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        if (!isExpanded) {
          Array.from(item.parentElement.children).forEach(function (sibling) {
            if (sibling === item) {
              return;
            }

            var siblingToggle = Array.from(sibling.children).find(function (child) {
              return child.classList && child.classList.contains('mobile-menu__submenu-toggle');
            });
            var siblingSubmenu = Array.from(sibling.children).find(function (child) {
              return child.tagName === 'UL';
            });

            if (siblingToggle && siblingSubmenu) {
              siblingToggle.setAttribute('aria-expanded', 'false');
              siblingSubmenu.hidden = true;
            }
          });
        }

        toggle.setAttribute('aria-expanded', String(!isExpanded));
        submenu.hidden = isExpanded;
      });
    });

    function lockScroll() {
      scrollPosition = { x: window.scrollX, y: window.scrollY };
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      var paddingRight = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;

      scrollProperties.forEach(function (property) {
        bodyStyles[property] = {
          value: document.body.style.getPropertyValue(property),
          priority: document.body.style.getPropertyPriority(property)
        };
      });

      document.body.style.position = 'fixed';
      document.body.style.top = -scrollPosition.y + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = paddingRight + scrollbarWidth + 'px';
    }

    function restorePage() {
      trigger.setAttribute('aria-expanded', 'false');

      if (!scrollPosition) {
        return;
      }

      scrollProperties.forEach(function (property) {
        var original = bodyStyles[property];
        if (original.value) {
          document.body.style.setProperty(property, original.value, original.priority);
        } else {
          document.body.style.removeProperty(property);
        }
      });

      window.scrollTo({ left: scrollPosition.x, top: scrollPosition.y, behavior: 'instant' });
      scrollPosition = null;
    }

    function closeMenu() {
      if (!dialog.open) {
        return;
      }

      dialog.close();
      // Unlock synchronously, before a clicked anchor performs its navigation.
      restorePage();
      if (mobile.matches) {
        trigger.focus({ preventScroll: true });
      }
    }

    trigger.addEventListener('click', function () {
      if (!mobile.matches || dialog.open) {
        return;
      }

      lockScroll();
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      closeButton.focus({ preventScroll: true });
    });

    closeButton.addEventListener('click', closeMenu);
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeMenu();
    });
    dialog.addEventListener('close', function () {
      // A queued close event must not unlock a menu that was immediately reopened.
      if (!dialog.open) {
        restorePage();
      }
    });

    function isOutsidePanel(event) {
      var bounds = dialog.getBoundingClientRect();
      return event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom;
    }

    dialog.addEventListener('pointerdown', function (event) {
      pointerStartedOutside = isOutsidePanel(event);
    });
    dialog.addEventListener('click', function (event) {
      if (event.target.closest('a[href]') || (pointerStartedOutside && isOutsidePanel(event))) {
        closeMenu();
      }
      pointerStartedOutside = false;
    });

    // Native modal dialog makes the page inert; keep Tab cycling inside its controls.
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') {
        return;
      }

      var controls = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]'))
        .filter(function (element) { return element.getClientRects().length > 0; });
      var first = controls[0];
      var last = controls[controls.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    mobile.addEventListener('change', function () {
      if (!mobile.matches) {
        closeMenu();
      }
    });
    window.addEventListener('pagehide', closeMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  } else {
    initMobileMenu();
  }
})();
